import { render, staticRenderFns } from "./Lainaus.vue?vue&type=template&id=38c8a954&scoped=true"
import script from "./Lainaus.vue?vue&type=script&lang=js"
export * from "./Lainaus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c8a954",
  null
  
)

export default component.exports